import { Link } from 'react-router-dom';
import { MessageCircle, Phone } from 'lucide-react';
import { getHoursLine, getWhatsAppUrl } from '../configs/contactInfo';
import { useSiteConfig } from '../configs/siteConfig';
import Logo from './site/Logo';
import './style.css';

const COLUMNS = [
  {
    title: 'Shop',
    links: [
      { to: '/products', label: 'All projects' },
      { to: '/code', label: 'Free source code' },
      { to: '/videos', label: 'Videos' },
      { to: '/reviews', label: 'Reviews' },
      { to: '/request-project', label: 'Request a project' },
    ],
  },
  {
    title: 'Company',
    links: [
      { to: '/about', label: 'About' },
      { to: '/how-we-work', label: 'How it works' },
      { to: '/help', label: 'Help Center' },
      { to: '/contact', label: 'Contact' },
    ],
  },
  {
    title: 'Policies',
    links: [
      { to: '/terms', label: 'Terms' },
      { to: '/privacy', label: 'Privacy' },
      { to: '/refund', label: 'Refund' },
    ],
  },
];

const FooterWidget = () => {
  const { contactInfo } = useSiteConfig();
  return (
    <footer className="footer-site">
      <div className="footer-inner">
        <div className="footer-top">
          <div className="footer-brand">
            <Link to="/" className="footer-logo" aria-label="Projects Kart home">
              <Logo />
            </Link>
            <p className="footer-tagline">{contactInfo.tagline}</p>
          </div>

          {COLUMNS.map(column => (
            <nav key={column.title} aria-label={column.title}>
              <h2 className="footer-heading">{column.title}</h2>
              <ul className="footer-links">
                {column.links.map(link => (
                  <li key={link.to}>
                    <Link to={link.to}>{link.label}</Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}

          <div>
            <h2 className="footer-heading">Contact</h2>
            <ul className="footer-links">
              <li>
                <a
                  href={getWhatsAppUrl(
                    `Hi ${contactInfo.companyName}, I have a question.`
                  )}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <MessageCircle aria-hidden="true" />
                  WhatsApp
                </a>
              </li>
              <li>
                <a href={`tel:${contactInfo.phone.primary.replace(/\s/g, '')}`}>
                  <Phone aria-hidden="true" />
                  {contactInfo.phone.display}
                </a>
              </li>
              <li className="footer-hours">{getHoursLine()}</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {new Date().getFullYear()} {contactInfo.companyName}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FooterWidget;
